import React from "react";
import { ArrowRight, Badge, Button } from "@opendate-app/setlist";

import { messageStyle } from "./Actions/SmsTab";
import { editorPath } from "./EmailPreview";

const containerStyle = {
  display: "flex",
  flexDirection: "column",
  gap: 12,
};

const headerStyle = {
  display: "flex",
  flexWrap: "wrap",
  alignItems: "center",
  justifyContent: "space-between",
  gap: 12,
};

const boxStyle = {
  border: "1px solid var(--sl-border-secondary)",
  borderRadius: 8,
  padding: 16,
  maxWidth: 500,
};

const SmsPreview = ({
  action,
}) => {
  return (
    <div style={containerStyle}>
      <div style={headerStyle}>
        <Badge color="pink">SMS Text Message 1</Badge>
        <Button size="sm" as="a" href={editorPath(action)} trailingIcon={ArrowRight}>Go to editor</Button>
      </div>
      <div style={boxStyle}>
        <div style={messageStyle}>
          {action.body}
        </div>
      </div>
    </div>
  );
};

export default SmsPreview;
